/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import ReplayIcon from '@mui/icons-material/Replay'
import RefreshIcon from '@mui/icons-material/Refresh'

import { aboutMeJSX } from './helpers/aboutMeJSX'
import { promptsJSX } from './helpers/promptsJSX'
import { hobbiesJSX } from './helpers/hobbiesJSX'
import { vitalInfoJSX } from './helpers/vitalInfoJSX'

import useWindowDimensions from '../../../helpers/windowDimensions'
import { standardButton, addImageWithTextButton, exitModalIconButton } from '../../../helpers/buttons'
import { standardSpinner } from '../../../helpers/spinners'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated, getEmailFromLocalStorage } from '../../../helpers/storage'
import { agesArray, positionChangeWidthSm, positionChangeWidthMd, swipelyticsPink, swipelyticsTurquoise, navbarHeight, footerHeight, dashboardNavbarHeight } from '../../../helpers/variableDefaults'
import { selectSortCategory } from '../../../helpers/selects'
import { couldNotLoadPageError } from '../../../helpers/errors'
import { switchWithTitle } from '../../../helpers/switches'
import { modifyInDatabase } from '../../../helpers/modifyInDatabase'
import { seoPageTags, customAnalyticsEvent } from '../../../helpers/analytics'
import { searchTextField } from '../../../helpers/textfields'
import { standardPagination } from '../../../helpers/pagination'
import { reloadView, numberWithCommas } from '../../../helpers/globalHelpers'

import { Input } from '../../../helpers/globalHelpers'

// Bio Page
const Bio = (props) => {

  const { isDemo, demoUser } = props

  // Window Dimensions
  const { height, width } = useWindowDimensions()
  
  // Navigate
  const navigate = useNavigate()

  // Params
  const { userId } = useParams()

  // Payload
  const payload = getPayload()

  // User
  const [user, setUser] = useState({})

  // Bio
  const [bioObject, setBioObject] = useState({
    aboutMe: [''], // Array of 'About Me' section strings
    prompts: [
      {
        prompt: '',
        response: '',
      },
      {
        prompt: '',
        response: '',
      },
      {
        prompt: '',
        response: '',
      }
    ], // Array of 'Prompt' objects; each Object has the keys: 'prompt' and 'response' 
    hobbies: ['', '', '', '', ''], // Array of 'hobbies' strings; 
    vitalInfo: {
      firstName: '', 
      age: -1,
      gender: '',
      sexuality: '',
      pronouns: '',
      interestedIn: '',
      interestedInAgeMin: agesArray[0],
      interestedInAgeMax: agesArray[agesArray.length - 1],
      heightInches: -1,
      heightCM: -1,
      inOrCmPreference: 'in',
      currentCity: '',
      hometown: '',
      languages: [],
      religion: [],
      politics: '',
      educationLevel: '',
      university: '',
      profession: '',
      employer: ``,
      children: '',
      familyPlans: '',
      datingIntentions: '',
      relationshipType: '',
      ethnicity: '',
      alcohol: '',
      cigarettes: '',
      weed: '',
      drugs: '',
      pets: [],
      zodiac: '',
      hidden: [],
    },
  })
  const [newAboutMe, setNewAboutMe] = useState([''])
  const [newPrompts, setNewPrompts] = useState([
    {
      prompt: '',
      response: '',
    },
    {
      prompt: '',
      response: '',
    },
    {
      prompt: '',
      response: '',
    }
  ])
  const [newHobbies, setNewHobbies] = useState(['', '', '', '', ''])
  const [newVitalInfo, setNewVitalInfo] = useState({
    firstName: '', 
    age: -1,
    gender: '',
    sexuality: '',
    pronouns: '',
    interestedIn: '',
    interestedInAgeMin: agesArray[0],
    interestedInAgeMax: agesArray[agesArray.length - 1],
    heightInches: -1,
    heightCM: -1,
    inOrCmPreference: 'in',
    currentCity: '',
    hometown: '',
    languages: [],
    religion: [],
    politics: '',
    educationLevel: '',
    university: '',
    profession: '',
    employer: ``,
    children: '',
    familyPlans: '',
    datingIntentions: '',
    relationshipType: '',
    ethnicity: '',
    alcohol: '',
    cigarettes: '',
    weed: '',
    drugs: '',
    pets: [],
    zodiac: '',
    hidden: [],
  })

  // Loading
  const [loading, setLoading] = useState(false)
  const [loadingAboutMe, setLoadingAboutMe] = useState(false)
  const [loadingPrompts, setLoadingPrompts] = useState(false)
  const [loadingHobbies, setLoadingHobbies] = useState(false)
  const [loadingVitalInfo, setLoadingVitalInfo] = useState(false)

  // Save Successful
  const [saveSuccessful, setSaveSuccessful] = useState({
    aboutMe: false,
    prompts: false,
    hobbies: false,
    vitalInfo: false,
  })

  // Errors
  const [errors, setErrors] = useState(false)
  const [bioErrors, setBioErrors] = useState({
    aboutMe: false,
    prompts: false,
    hobbies: false,
    vitalInfo: false,
  })

  // UseEffect — Send to user their own dashboard if payload doesn't match userId
  useEffect(() => {

    if (isDemo) {
      setUser({ ...demoUser })
      setBioObject({ ...demoUser.bio })
      setNewAboutMe([ ...demoUser.bio.aboutMe])
      setNewPrompts([ ...demoUser.bio.prompts ])
      setNewHobbies([ ...demoUser.bio.hobbies])
      setNewVitalInfo({ ...newVitalInfo, ...demoUser.bio.vitalInfo })
    } else if (!userIsAuthenticated()) {
      navigate('/login')
    } else if (userId !== payload.sub) {
      navigate(`/dashboard/${payload.sub}`, { state: { previousLocationPathname: window.location.pathname } })
      // reloadView()
    } else {
      const getData = async () => {
        setLoading(true)
        try {
          const { data: retrievedUser } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${payload.sub}`, {
            headers: {
              Authorization: `Bearer ${getTokenFromLocalStorage()}`,
            },
          })
          // console.log('retrieved User ->', retrievedUser)

          if (payload.sub === retrievedUser._id) {
            // Set States
            setUser(retrievedUser)
            setBioObject(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null ? { ...retrievedUser.bio } : bioObject)
            setNewAboutMe(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'aboutMe' in retrievedUser.bio && retrievedUser.bio.aboutMe.length > 0 ? [ ...retrievedUser.bio.aboutMe] : newAboutMe)
            setNewPrompts(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'prompts' in retrievedUser.bio && retrievedUser.bio.prompts.length > 0 ? [ ...retrievedUser.bio.prompts ] : newPrompts)
            setNewHobbies(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'hobbies' in retrievedUser.bio && retrievedUser.bio.hobbies.length > 0 ? [ ...retrievedUser.bio.hobbies] : newHobbies)
            setNewVitalInfo(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'vitalInfo' in retrievedUser.bio && Object.keys(retrievedUser.bio.vitalInfo).length > 0 ? { ...newVitalInfo, ...retrievedUser.bio.vitalInfo } : newVitalInfo)
            
            setErrors(false)
            setLoading(false)
          } else {
            navigate(`/`)
            setErrors(false)
            setLoading(false)
          }

        } catch (error) {
          // console.log(error)

          navigate(`/`)

          setErrors(true)
          setLoading(false)
        }
      }

      getData()
    }

  }, [])

  useEffect(() => {
    // console.log('useEffect Runs')

  }, [newAboutMe, newPrompts, newHobbies, newVitalInfo, saveSuccessful, bioErrors])

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        'My Bio'
      )}

      {/* Body */}
      {loading ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        :
        errors ? 
          <Box
            sx={{
              // backgroundColor: 'yellow',
              width: '100%',
              minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
            }}
          >
            {couldNotLoadPageError()}
          </Box>
          :
          <Box
            sx={{
              // backgroundColor: 'green',
              pt: 3, pb: 3,
              width: '100%',
              minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          > 
            <Box sx={{ width: '100%' }}>
              <Input type="text" autoFocus="autoFocus" />
            </Box>
            {/* Inactive Subscription */}
            {user.hasOwnProperty('subscriptionIsActive') && !user.subscriptionIsActive &&
              <Box
                sx={{
                  backgroundColor: 'red',
                  color: 'white',
                  py: 3, px: 3,
                  width: '100%', 
                  // height: '100px',
                  fontSize: '18px', fontWeight: 'bold',
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {`Click 'Manage Subscription' in the 'Settings' tab to reactivate subscription`}
              </Box>
            }
            
            {/* About Me */}
            {aboutMeJSX(
              bioObject, setBioObject,
              newAboutMe, setNewAboutMe,
              loadingAboutMe, setLoadingAboutMe,
              saveSuccessful, setSaveSuccessful,
              bioErrors, setBioErrors,
              width,
              isDemo
            )}
            
            {/* Prompts */}
            {promptsJSX(
              bioObject, setBioObject,
              newPrompts, setNewPrompts,
              loadingPrompts, setLoadingPrompts,
              saveSuccessful, setSaveSuccessful,
              bioErrors, setBioErrors,
              width,
              isDemo
            )}

            {/* Hobbies */}
            {hobbiesJSX(
              bioObject, setBioObject,
              newHobbies, setNewHobbies,
              loadingHobbies, setLoadingHobbies,
              saveSuccessful, setSaveSuccessful,
              bioErrors, setBioErrors,
              width,
              isDemo
            )}
            
            {/* Vital Info */}
            {vitalInfoJSX(
              'bio',
              bioObject, setBioObject,
              newVitalInfo, setNewVitalInfo,
              loadingVitalInfo, setLoadingVitalInfo,
              saveSuccessful, setSaveSuccessful,
              bioErrors, setBioErrors,
              width,
              isDemo
            )}
          </Box>
      }
    </>
  )
}

export default Bio